import { Switch } from './Switch';

export { Switch };
export default Switch;
